// import { getUserInfo, openTenant } from '@/api/oauth2/user'
import { get } from '@/api/platform/system/member'

// import { getUserInfo, switchUser, exitSwitchUser, openUser, openTenant } from '@/api/oauth2/user'
import Utils from '@/utils/util'

export default {
  namespaced: true,
  state: {
    // 会员信息
    member: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set({ state, dispatch }, member) {
      return new Promise(async resolve => {
        // store 赋值
        state.member = member
        // 持久化
        await dispatch('ibps/db/set', {
          dbName: 'sys',
          path: 'member.info',
          value: member,
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} state vuex state
     */
    get({ state, dispatch }) {
      return new Promise(async resolve => {
        // store 赋值
        state.member = await dispatch('ibps/db/get', {
          dbName: 'sys',
          path: 'member.info',
          defaultValue: {},
          user: false
        }, { root: true })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取会员数据
     * @param {Object} context
     */
    load({ state, dispatch }, id) {
      // console.log('load')
      return new Promise(async(resolve, reject) => {
        get(id).then(async response => {
          if (!response) {
            reject(response)
          }

          // 设置当前
          await dispatch('set', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
